import React, {Component} from 'react';
import {connect} from 'react-redux';

class MultiSelect extends Component {
    constructor(props) {
        //console.log("MultiSelect["+props.configSearch.id+"]::constructor()")
                super(props);
        this.state = {
            data: [],
        };
        this.filter = this.filter.bind(this);
        this.hasChange = this.hasChange.bind(this);
    }
    
    render() {
        //console.log("MultiSelect["+this.props.configSearch.id+"]::render()")
                const {id, collSize, idSelect} = this.props.configSearch;
        return (
            <div id={id} className={collSize}>
                <div className="form-group">
                    <select
                        id={idSelect}
                        className="form-control select2-form-control select2"
                        multiple="multiple"
                    >
                    </select>
                </div>
            </div>
        );
    }
    
    filter(data) {
        if (this.state.data.findIndex((x) => x.id === '0') >= 0 && data.length > 1) {
            return data.filter((x) => x.id !== '0');
        } else if (this.state.data.findIndex((x) => x.id === '0') < 0 && data.findIndex((x) => x.id === '0') >= 0) {
            return data.filter((x) => x.id === '0');
        } else {
            return data;
        }
    }
    
    hasChange(dataprev, data) {
        return !data.every((x) => dataprev.findIndex((y) => y.id === x.id) >= 0);
    }
    
    componentDidMount() {
        //console.log("MultiSelect["+this.props.configSearch.id+"]::componentDidMount()")
        const selectElem = $('#' + this.props.configSearch.idSelect);
        if (selectElem) {
            const select2 = selectElem.select2();
            const data = this.props.configSearch.all
                ? [{id: 0, text: this.props.configSearch.all.text}, ...this.props.data]
                : this.props.data;
            
            select2.empty();
            select2.select2({
                //id: this.props.configSearch.initialValue,
                data: data,
                placeholder: this.props.configSearch.placeHolder,
                maximumSelectionLength: this.props.configSearch.limit,
                language: {
                    maximumSelected: (limit) => {
                        return ('Sólo puedes seleccionar máximo ' + limit.maximum + ' ' + (this.props.configSearch.idSelect + (/[aeiou]$/.test(this.props.configSearch.idSelect) ? 's' : 'es')));
                    },
                },
            });
            
            //Cargar seleccionados
            if (this.props.configSearch.seleccionado && this.props.configSearch.seleccionado.length > 0) {
                select2.val(this.props.configSearch.seleccionado.map((sel) => {
                    const index = data.findIndex((x) => x.text.toLowerCase() === sel.toLowerCase())
                    return data[index] ? data[index].id.toString() : undefined;
                })).trigger('change');
                
                const dataFilter = select2.select2('data');
                const dataChanged = this.filter(dataFilter);
                this.setState({
                    data: dataChanged,
                });
            } else if (this.props.configSearch.initialValue !== undefined && this.props.configSearch.seleccionado.length === 0) {
                select2.val(this.props.configSearch.initialValue.toString()).trigger('change');
            } else {
            }
            
            //Observador de modificación.
            const that = this;
            selectElem.on('select2:select select2:unselect', () => {
                const dataFilter = select2.select2('data');
                const dataChanged = that.filter(dataFilter);
                const dataTexts = dataChanged.map((element) => {
                    return element.text;
                });
                that.props.configSearch.methodChange(dataTexts);
                that.setState({
                    data: dataChanged,
                });
                
            });
        }
        
        $('#' + this.props.configSearch.id).find('input')[0].placeholder = this.props.configSearch.placeHolder
    }
    
    componentDidUpdate(prevProps, prevState, prevContext) {
        // console.log("MultiSelect["+this.props.configSearch.id+"]::componentDidUpdate()")

        let selectElem = $('#' + this.props.configSearch.idSelect);
        if (prevProps.data.length !== this.props.data.length && selectElem) {
            
            let select2 = selectElem.select2();
            const data = this.props.configSearch.all
                ? [
                    {id: 0, text: this.props.configSearch.all.text},
                    ...this.props.data,
                ]
                : this.props.data;
            
            select2.empty();
            let that = this;
            select2.select2({
                data: data,
                placeholder: that.props.configSearch.placeHolder,
            });
        }
        if (prevProps.seleccionados !== undefined &&
            this.props.seleccionados.length > 0 &&
            prevProps.seleccionados.length !== this.props.seleccionados.length && selectElem) {
            let select2 = selectElem.select2();
            const data = this.props.configSearch.all
                ? [
                    {id: 0, text: this.props.configSearch.all.text},
                    ...this.props.data,
                ]
                : this.props.data;
            
            select2.val(this.props.seleccionados.map((sel) => {
                const index = data.findIndex((x) => x.text.toLowerCase() === sel.toLowerCase())
                return data[index] ? data[index].id.toString() : undefined;
            })).trigger('change');
            
            select2.select2({
                placeholder: this.props.configSearch.placeHolder,
            });
        }
        
        if (prevState.data.length > 0 && this.hasChange(prevState.data, this.state.data) && selectElem) {
            const data = this.props.configSearch.all
                ? [{id: 0, text: this.props.configSearch.all.text}, ...this.props.data,] : this.props.data;
    
            selectElem.val(this.state.data.map((sel) => {
                    return data[data.findIndex((x) => x.text.toLowerCase() === sel.text.toLowerCase())].id.toString();
                })
            ).trigger('change');
        }
        
        $('#' + this.props.configSearch.id).find('input')[0].placeholder = this.props.configSearch.placeHolder
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default MultiSelect;
